import React, { lazy } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import { PartnerProtectedRoute, PartnerPublicRoute, RedirectWrapper } from '@app/routes/components';
import { useHandlePartnerRedirects } from '@app/routes/hooks';

const YatConfirmConnect = lazy(() => import('@app/pages/v2/Connect/YatConfirmConnect'));
const YatManageMultiple = lazy(() => import('@app/pages/v2/Connect/ManageMultipleYats'));
const SelectWallet = lazy(() => import('@app/pages/v2/Connect/ManageMultipleYats/SelectWallet'));
const NoYatsYet = lazy(() => import('@app/pages/v2/Connect/NoYats'));
const AccountLinkSuccess = lazy(() => import('@app/pages/v2/Connect/YatAccountLinkSuccess'));
const SkipAccountCreation = lazy(() => import('@app/pages/v2/Connect/YatSkipAccountCreation'));
const LinkEmail = lazy(() => import('@app/pages/v2/Connect/YatLinkEmail'));
const CreateYourYat = lazy(() => import('@app/pages/v2/Connect/YatCreateYourYat'));

export const PartnerRoutes = () => {
    const { redirectTo } = useHandlePartnerRedirects();
    return (
        <Routes>
            <Route element={<PartnerProtectedRoute />}>
                <Route path="create-success" element={<AccountLinkSuccess />} />
                <Route path="connect-wallet" element={<SelectWallet />} />
                <Route path="skip" element={<SkipAccountCreation />} />
            </Route>

            <Route element={<RedirectWrapper redirectTo={redirectTo} />}>
                <Route path="confirm" element={<YatConfirmConnect />} />
                <Route path="manage" element={<YatManageMultiple />} />
                <Route path="create" element={<NoYatsYet />} />
            </Route>

            <Route element={<PartnerPublicRoute />}>
                <Route path="create-account" element={<LinkEmail />} />
                <Route path="link-email" element={<LinkEmail />} />
            </Route>
            <Route index element={<CreateYourYat />} />
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};
